export const TESTS = {
    GDPR: 'ha_gdpr_banner',
    REDESIGN_QA_SEO_TEXT: 'HA_PTA_LANDING_RedesignQASEOText',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    LOW_LEVEL_GEO_TEMPLATE: 'HA_PTA_LANDING_LowLevelGeoSLPTemplate',
    HIGH_LEVEL_GEO_TEMPLATE: 'HA_PTA_LANDING_HighLevelGeoSLPTemplate',
    PROPERTY_TYPE_NAME_LISTING_CARDS: 'HA_PTA_LANDING_PropertyTypeNameListingCards',
    STREAM_LANDING: 'HA_PTA_SLP_StreamLanding',
    ORIGIN_CORRIDOR_DESTINATIONS: 'HA_PTA_LANDING_SLPOriginCorridorDestinations',
    DISCOVERY_PROPERTY_FEED: 'HA_PTA_LANDING_DiscoveryfeedSLPs',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    DISCOVERY_DESTINATIONS: 'HA_PTA_LANDING_DestinationDiscoveryfeedSLPs',
    DESTINATION_RECOMMENDATIONS: 'HA_PTA_LANDING_SimilarDestinationsonSLPs',
    SEO_LINK_PILE_ON_ROOT_PAGE: 'HA_PTA_LANDING_SLPRootOnPlatformLinkpile',
    MLP_SEO_LINKPILE: 'HA_PTA_LANDING_MLPOnPlatformLinkpile',
    SEO_LINK_PILE_ON_DESTINATION_PAGE: 'HA_PTA_LANDING_SLPOnPlatformSEOLinkpileExpanded',
    JUMBOTRON_HEADING_TEXT: 'HA_PTA_LANDING_SLP_KeywordInH1',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    BREADCRUMB_IN_HEADER: 'HA_PTA_LANDING_SLPReduceAndRepositionBreadcrumb',
    HA_TYPEAHEAD_HIGHLIGHTS: 'ha_typeahead_highlights',
    HA_TYPEAHEAD_SCROLL_TO_TOP: 'HA_TYPEAHEAD_SCROLL_TO_TOP',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display',
    MAP_PROPERTIES_REDESIGN_MOBILE: 'HA_PTA_LANDING_MapPropertiesRedesignMobile',
    MAP_PROPERTIES_REDESIGN_DESKTOP: 'HA_PTA_LANDING_MapPropertiesRedesignDesktop',
    SEARCH_FORM_SLP: 'HA_PTA_SEARCH_FORM_SLP',
    SEARCH_FORM_MLP: 'HA_PTA_Search_Form_MLP',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    DATELESS_RANKING: 'HA_PTA_LANDING_DatelessRanking',
    LANDING_NEW_HEADINGS: 'HA_PTA_LANDING_NewHeadings',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    DYNAMIC_SEO_INTRO_PARAGRAPH: 'HA_PTA_LANDING_SLPDynamicIntroParagraph'
};

export const EVALUATE = [
    TESTS.GDPR,
    TESTS.REDESIGN_QA_SEO_TEXT,
    TESTS.POLYFILL_SERVICE,
    TESTS.LOW_LEVEL_GEO_TEMPLATE,
    TESTS.HIGH_LEVEL_GEO_TEMPLATE,
    TESTS.PROPERTY_TYPE_NAME_LISTING_CARDS,
    TESTS.STREAM_LANDING,
    TESTS.ORIGIN_CORRIDOR_DESTINATIONS,
    TESTS.DISCOVERY_PROPERTY_FEED,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.DISCOVERY_DESTINATIONS,
    TESTS.DESTINATION_RECOMMENDATIONS,
    TESTS.SEO_LINK_PILE_ON_ROOT_PAGE,
    TESTS.MLP_SEO_LINKPILE,
    TESTS.SEO_LINK_PILE_ON_DESTINATION_PAGE,
    TESTS.JUMBOTRON_HEADING_TEXT,
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.HA_TYPEAHEAD_HIGHLIGHTS,
    TESTS.HA_TYPEAHEAD_SCROLL_TO_TOP,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.MAP_PROPERTIES_REDESIGN_MOBILE,
    TESTS.MAP_PROPERTIES_REDESIGN_DESKTOP,
    TESTS.SEARCH_FORM_SLP,
    TESTS.SEARCH_FORM_MLP,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.DATELESS_RANKING,
    TESTS.LANDING_NEW_HEADINGS,
    TESTS.HA_PTA_HEADER_LOGIN_COPY,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    return hasTest(abacus, test) ?
        abacus[test].value :
        null;
};
